<script lang="ts">
  import {
    Badge,
    Button,
    Card,
    Col,
    Collapse,
    Container,
    Modal,
    ModalHeader,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Row,
    Styles,
    Tooltip
  } from 'sveltestrap';


  let user={'name':'None','logged':false};

  let password='';

  function login(){
		if(password=='t3$t2001')
		{
			user.logged=true;
		}
		else{
			logout();
		}
	}




  function logout(){
	
	user={'name':'None','logged':false};

  }


  let color_pricing='primary';
  let color_pricing_dark='info';
  let isOpen = false;

  let pane = 'main';

  function handlehref(page) 
  {

	pane=page;

  }

  function handleUpdate(event) {
    isOpen = event.detail.isOpen;
  }


  let modalopen = false;
  const modaltoggle = () => (modalopen = !modalopen);

  let OpenLogin = false;  
  const ModalToggleLogin = () => (OpenLogin = !OpenLogin);



</script>
<Styles/>
<Navbar color="light" light expand="md">
  <NavbarBrand href="/">nonce</NavbarBrand>
  <NavbarToggler on:click={() => (isOpen = !isOpen)} />
  <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
    <Nav class="ms-auto" navbar>
    {#if !user.logged}
        <NavItem class="navbar_top_nolink"><NavLink on:click={()=>(pane='about')}>About</NavLink></NavItem>
      <Dropdown nav inNavbar class="navbar_top">
        <DropdownToggle nav caret >Trading</DropdownToggle>
        <DropdownMenu end dark>
          <DropdownItem class="navbar_top">Strategy</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top">Results</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top" on:click={()=>(pane='backtest')} >Backtesting</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top" on:click={()=>(pane='ttt')}>Execution</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top">Risk</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      {/if}
      
      <Dropdown nav inNavbar class="navbar_top">
        <DropdownToggle nav caret class="navbar_top">FAQs</DropdownToggle>
        <DropdownMenu end dark>
          <DropdownItem class="navbar_top">Trading Issues</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top">Account Setup</DropdownItem>
          <DropdownItem divider />
          <DropdownItem class="navbar_top">Refunds</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      
      {#if ! user.logged}
      <NavItem class="navbar_top_nolink"><NavLink on:click={()=>(pane='pricing')}>Pricing</NavLink></NavItem>
      
      <NavItem class="navbar_top_nolink"><NavLink on:click={()=>(pane='contact')}>Contact</NavLink></NavItem>
      {/if}


      {#if ! user.logged}
      <div class="pad5px">
      <NavItem><Button primary size="sm" class="button" on:click={()=>(OpenLogin=!OpenLogin)}>Login</Button></NavItem></div>
      <div class="pad5px">
      <NavItem><Button primary size="sm" class="button" on:click={()=>(pane='pricing')}>Register</Button></NavItem></div>
      {:else}
      <div class="pad5px">
      <NavItem><Button primary size="sm" class="button" on:click={logout}>Logout {user.name}</Button></NavItem>
      </div>
      {/if}
    </Nav>
  </Collapse>
</Navbar>



{#if pane=='pricing' & ! user.logged} 
<Container>
<Row>
<Col><div><h3 class="pad10px"> Pricing plans... </h3></div> </Col>
</Row>
<Row>
<Col class="pad20px">
	<Card body color="light" class="rounded background_gray">
	<div>
	<h2>$0</h2><Badge color="secondary">KiKi</Badge>
	</div>
	<br>
		<span id='test'>✓ 1 AI powered hedging bot</span>
		<Tooltip target='test' placement='bottom'>Bot that opens upto 4 positions.</Tooltip>
		✓ Unlimited Augmented-DCA signals<br>
		- 4 fixed symbols<br>
		<span id='shared_resource'>- Shared resource</span>
		<Tooltip target='shared_resource' placement='bottom'>Shared resource implies compute shared among a group of participants and prioritised based on a first-come-first-serve basis. On a shared resource, price slippage can occur during volatile conditions.</Tooltip><br>
		<br>
       
	<div>
	<Button color="secondary" size="sm">Sign Up</Button>
	</div>
	</Card>

</Col>
<Col class="pad20px">
	<Card body color="secondary" class="white">
	<div>
	<h2>$10 </h2><Badge color="dark" >Totoro</Badge>
	</div>
	<br>
		✓ 5 hedging bots<br>
		✓ 1 sentiment bot<br>
		✓ Dedicated resource<br>
	<br>
	<div>
	<Button color="light" size="sm">Sign Up</Button>
	</div>
	</Card>
</Col>
<Col class="pad20px">
	
	<Card body color="dark" class="white">
	<h2>15% rev share</h2>
	<div>
	<Badge color="secondary">Laputa</Badge>
	</div>
	<br>
		✓ DEX trades<br>
		✓ Statistical Arbitrage<br>
		✓ Commission only on profitable trades<br>
		✓ Dedicated resource<br>
  <br>
  <div>
  <Button color="light" size="sm" on:click={modaltoggle}>Sign Up</Button>
  </div>
	</Card>
</Col>
</Row>
</Container>
  <Modal isOpen={modalopen} {modaltoggle}>
  <ModalHeader class="align_right">
  <div class="align_right"><Button on:click={()=>(modalopen=!modalopen)}>X</Button></div></ModalHeader>
    <div class="pad15px">
    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua.<br><br>
  	<div>
  	<Button color="info" on:click={()=>(modalopen=!modalopen)}>Signup</Button>
	</div>
    </div>
  </Modal>
{/if}


  {#if ! user.logged}
  <Modal isOpen={OpenLogin} {ModalToggleLogin}>
  <ModalHeader class="align_right">
  	<div class="align_right"><Button on:click={()=>(OpenLogin=!OpenLogin)}>X</Button></div></ModalHeader>
  <div class="pad15px">
	<div class="pad5px"> Login using: <br></div>
	<div>
	<input id="password" type="password" bind:value={password} >
	<Button color="primary" on:click={()=>(login())}>Login</Button>
	</div>
	<br>
	<span class="pad5px"><Button>Google</Button></span>
	<span class="pad5px"><Button>Facebook</Button></span>
	<span class="pad5px"><Button>Twitter</Button></span>
  </div>
  </Modal>
  {/if}

<br>
<div class="bottom_bar">
		nonce<br>
                A Western Australian Startup <br>
                ABN: 292-2093 <br>
                <br>
</div>


